import { Smartphone, Bell, QrCode, History, ArrowUpRight } from "lucide-react";
import { FadeUp } from "@/components/web/Reveal";

const PLAY_URL = "https://play.google.com/store/apps/details?id=com.emergent.linkshieldai.lmnv0s";

const FEATURES = [
  { icon: Bell, label: "Notification link scanning" },
  { icon: QrCode, label: "QR code scanning" },
  { icon: History, label: "Scan history & security alerts" },
];

export const MobileAppCta = () => (
  <section data-testid="mobile-app-cta-section" className="py-24 sm:py-32 border-t border-white/10 bg-[#0A121D]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
      <FadeUp className="lg:col-span-7">
        <p className="ls-overline mb-4">Mobile</p>
        <h2 className="font-heading font-black text-3xl sm:text-5xl tracking-tighter text-white text-balance">
          Protect your links
          <span className="text-[#00C5FE]"> wherever they arrive.</span>
        </h2>
        <p className="mt-6 text-zinc-400 leading-relaxed max-w-xl">
          The LinkExpln mobile app brings the shield to your pocket —
          scanning links from notifications, QR codes and your clipboard,
          with instant security alerts when something looks wrong.
        </p>
        <ul className="mt-8 space-y-4">
          {FEATURES.map((f) => (
            <li key={f.label} className="flex items-center gap-3">
              <f.icon size={18} className="text-[#00C5FE] shrink-0" />
              <span className="text-zinc-300 text-sm sm:text-base">{f.label}</span>
            </li>
          ))}
        </ul>
        <div className="mt-10 flex flex-wrap items-center gap-4">
          <a
            href={PLAY_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-app-play-cta"
            className="inline-flex items-center gap-2 btn-brand text-black font-heading font-bold text-sm px-6 py-3.5 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#00C5FE] focus:ring-offset-2 focus:ring-offset-black"
          >
            Download on Google Play <ArrowUpRight size={16} strokeWidth={2.5} />
          </a>
          <div
            data-testid="mobile-app-available-badge"
            className="inline-flex items-center gap-3 border border-[#00C5FE]/30 bg-[#00C5FE]/5 px-5 py-3"
          >
            <Smartphone size={15} className="text-[#00C5FE] shrink-0" />
            <p className="font-mono-ls text-[11px] sm:text-xs tracking-[0.15em] uppercase text-[#00C5FE]">
              Now available on Google Play
            </p>
          </div>
        </div>
      </FadeUp>
      <FadeUp delay={0.15} className="lg:col-span-5">
        <div className="relative border border-white/10 bg-black p-8 sm:p-10">
          <Smartphone size={28} className="text-[#00C5FE] mb-6" />
          <p className="font-mono-ls text-[11px] tracking-[0.2em] uppercase text-zinc-400 mb-3">
            INCOMING NOTIFICATION
          </p>
          <div className="border border-white/10 bg-[#0A121D] p-4">
            <p className="text-sm text-zinc-300">&ldquo;Your package is held — confirm here: hxxps://track-parcel…&rdquo;</p>
          </div>
          <div className="mt-3 border border-[#FF3366]/40 bg-[#FF3366]/5 p-4">
            <p className="font-mono-ls text-[11px] tracking-[0.15em] uppercase text-[#FF3366]">
              ⚠ LINKEXPLN: DANGEROUS LINK DETECTED
            </p>
            <p className="mt-2 text-xs text-zinc-400 leading-relaxed">
              Lookalike domain · flagged by threat intelligence · do not open
            </p>
          </div>
        </div>
      </FadeUp>
    </div>
  </section>
);
